import React, {
  useEffect,
  useRef,
  useState,
  useMemo,
  useCallback,
} from "react";
import store from "@/stores/clipEditor/player";
import { videoDecoder } from "@/utils/webcodecs";
import {
  VideoMaterial,
  VideoGroup as VideoTrackProps,
} from "@/stores/clip/class/VideoTrack";
import { getGridPixel } from "@/utils/canvasUtil";
import trackStateStore from "@/stores/clipEditor/trackState";
import { debounce } from "@/utils";
import { formatPlayerTime } from "@/utils/tool";
import useDebounce from "@/hooks/useDebounce";
import { Spin } from "@arco-design/web-react";
import "./videoItem.less";

interface VideoTrackItem {
  name: string;
  format: string;
  time: string;
  source: string;
  start: number;
  end: number;
  offsetL: number;
  offsetR: number;
  frameCount: number;
  width: number;
  height: number;
}

interface VideoItemProps {
  trackItem: VideoTrackProps;
}

const VideoGroup: React.FC<VideoItemProps> = ({ trackItem }) => {
  const myCanvas = useRef(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const [loading, setLoading] = useState(true);
  const [imgs, setImgs] = useState<string[]>([]);
  const [containerWidth, setContainerWidth] = useState(100);

  const trackStyle = useMemo(() => {
    return {
      width:
        getGridPixel(
          trackStateStore.trackScale,
          trackStateStore.getFrameCount()
        ) + 200,
    };
  }, [trackStateStore.trackScale, trackItem.offsetL, trackItem.offsetR]);

  useEffect(() => {
    if (!trackItem?.source) {
      setLoading(false);
      return;
    }
    store.ingLoadingCount++;
    console.log("trackItem.source", trackItem.source);

    initVideo();
    return () => {
      // imgs.forEach((item) => {
      //   URL.revokeObjectURL(item);
      // });
      videoDecoder.cancel();
    };
  }, [trackItem.source]);

  // 格式化播放时间
  const playTime = useMemo(() => {
    return formatPlayerTime(store.playStartFrame);
  }, [store.playStartFrame]);

  // 格式化总时间
  const allTime = useMemo(() => {
    return formatPlayerTime(trackStateStore.getFrameCount());
  }, [trackStateStore.getFrameCount()]);

  const imgH = 41.16;
  const imgW = useMemo(() => {
    console.log("imgW", (41 * trackItem.width) / trackItem.height);

    return (imgH * trackItem.width) / trackItem.height;
  }, []);

  const initVideo = async () => {
    if (imgs.length) return;
    const source = trackItem.source;
    const start = performance.now();
    const thumbnails = await videoDecoder.thumbnails(
      source as unknown as VideoMaterial
    );
    console.log(
      `生成${thumbnails.length}张缩略图耗时`,
      thumbnails,
      performance.now() - start,
      "ms"
    );
    const imgUrls = thumbnails?.map(({ img }) => URL.createObjectURL(img));

    setImgs(imgUrls);
    // console.log("缩略图连接耗时", performance.now() - start, "ms");
    setLoading(false);
    store.ingLoadingCount--;
  };

  // useResizeObserver(containerRef, (entries) => {
  //   const entry = entries[0];
  //   const { width } = entry.contentRect;
  //   setContainerWidth(width);
  // });

  useEffect(() => {
    const target = containerRef.current;
    if (!target) return;

    const resizeObserver = new ResizeObserver((entries) => {
      const { width } = entries[0].contentRect;
      console.log("container width-------", width);
      if (!width) return;
      setContainerWidth(width);
    });

    resizeObserver.observe(target);

    return () => {
      resizeObserver.unobserve(target);
    };
  }, []);

  const getUniformSubarray = (array: string[], m: number) => {
    const interval = array.length / m;
    const subarray = [];
    for (let i = 0; i < array.length && subarray.length < m; i += interval) {
      subarray.push(array[Math.min(Math.round(i), array.length - 1)]);
    }
    return subarray;
  };

  // const genThumbCanvas = useDebounce(() => {
  //   // console.log("genCanvas====================");
  //   const canvas: any = myCanvas.current;
  //   if (!canvas) return;
  //   const ctx = canvas.getContext("2d");
  //   ctx.clearRect(0, 0, canvas.width, canvas.height);
  //   thumbnails.forEach((url, i) => {
  //     addImgToCanvans(url, i);
  //   });
  //   // trackStateStore.updateGroup(
  //   //   trackStateStore.selectGroupItem.line,
  //   //   trackStateStore.selectGroupItem.index,
  //   //   {
  //   //     end: trackItem.start + 30 * 10,
  //   //     offsetR: trackItem.frameCount - 30 * 10,
  //   //   }
  //   // );
  // }, 500);

  const thumbnails = useMemo(() => {
    if (imgs.length === 0) return [];
    const { start, end, frameCount } = trackItem;
    const showFrameCount = end - start;
    console.log(
      imgs,
      end,
      start,
      "需要显示的图片数量============",
      containerWidth,
      frameCount,
      showFrameCount,
      Math.ceil((containerWidth * frameCount) / showFrameCount / imgW)
    );

    return getUniformSubarray(
      imgs,
      Math.ceil((containerWidth * frameCount) / showFrameCount / imgW) // 计算出需要显示的图片数量
    );
  }, [imgs, containerWidth]);

  // useEffect(() => {
  //   if (!thumbnails.length) return;
  //   console.log(
  //     thumbnails,
  //     trackStateStore.trackScale,
  //     trackItem.offsetL,
  //     trackItem.offsetR
  //   );
  //   genThumbCanvas();
  // }, [
  //   thumbnails.length,
  //   trackStateStore.trackScale,
  //   trackItem.offsetL,
  //   trackItem.offsetR,
  // ]);

  const addImgToCanvans = (url, i) => {
    const canvas: any = myCanvas.current;
    const ctx = canvas.getContext("2d");
    const imgObj = new Image();
    imgObj.src = url;
    imgObj.onload = function () {
      ctx.drawImage(imgObj, i * imgW, 0, imgW, imgH);
    };
  };

  const waveStyle = useMemo(() => {
    const { start, end, offsetL, offsetR, frameCount } = trackItem;
    const showFrameCount = end - start;
    return {
      transformOrigin: "left top",
      left: `-${(offsetL / showFrameCount) * 100}%`,
      right: `-${(offsetR / showFrameCount) * 100}%`,
      width: `${(frameCount / showFrameCount) * 100}%`,
    };
  }, [trackItem]);

  const dropStyle = useMemo(() => {
    const { start, end, offsetL, offsetR, frameCount } = trackItem;
    const showFrameCount = end - start;
    return {
      left: `${(offsetL / frameCount) * 100}%`,
      right: `${(offsetR / frameCount) * 100}%`,
    };
  }, [trackItem]);

  return (
    <div
      className="img-wrapper"
      style={{
        display: "flex",
        flexDirection: "column",
        // overflow: "hidden",
        height: "99%",
      }}
      ref={containerRef}
    >
      <div
        style={{
          overflow: "hidden",
          flex: 1,
          position: "relative",
          whiteSpace: "nowrap",
          borderRadius: "8px",
          ...waveStyle,
        }}
      >
        <div
          className="left-drop"
          style={{
            position: "absolute",
            width: dropStyle.left,
            height: "100%",
            left: "0",
            top: 0,
            background: "rgba(255, 255, 255, 0.4)",
          }}
        ></div>
        <div
          className="right-drop"
          style={{
            position: "absolute",
            width: dropStyle.right,
            height: "100%",
            right: "0",
            top: 0,
            background: "rgba(255, 255, 255, 0.4)",
          }}
        ></div>
        {thumbnails.map((item, index) => (
          <img
            key={index}
            src={item}
            alt=""
            className="image-item"
            style={{ height: "100%", userSelect: "none" }}
            draggable="false"
          />
        ))}
        {/* <canvas
          style={{ display: "block", marginBottom: 1 }}
          ref={myCanvas}
          width={trackStyle.width}
          height="41"
        /> */}
      </div>

      {!!loading && (
        <div
          style={{
            position: "absolute",
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            background: "rgba(255, 255, 255, 0.6)",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: 6,
              left: 12,
              display: "flex",
              alignItems: "center",
              color: "#165dff",
              fontSize: 12,
            }}
          >
            <Spin style={{ marginRight: 5 }} /> 解析中..
          </div>
        </div>
      )}
    </div>
  );
};

export default VideoGroup;
